export default __webpack_public_path__ + "static/media/46.d2884c0c.png";